/* eslint-disable  no-irregular-whitespace */
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { UIHeading2, UIText2, UIText3, Button, LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import { ICPDPrelandingContent } from 'shared/containers/valuationTraps/CPDTrap/types';
import { useCpdTracking } from 'shared/containers/valuationTraps/utils/tracking/cpd';
import { TCategory } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import * as styles from './styles.css';
import { ECpdDraftStatus } from '../../../types/cpd/cpd';

interface ICPDPrelandingProps {
  onCreateDraftCpd: () => void;
  cpdDraftStatus: ECpdDraftStatus;
  prelandingContent: ICPDPrelandingContent;
  category: TCategory;
}

export const CPDPrelanding: React.FC<ICPDPrelandingProps> = ({
  onCreateDraftCpd,
  cpdDraftStatus,
  prelandingContent,
  category,
}) => {
  const { trackCPDDetailClick, trackCPDModalVisible } = useCpdTracking();
  const { mainImgUrl, title, points, primaryBtnText, secondaryBtn, securyPersonalUrl, securyСonfidentialityUrl } =
    prelandingContent;

  const cpdLandingLink = secondaryBtn && `${secondaryBtn.url}&offerCategory=${category}`;

  return (
    <ActionAfterViewObserver callback={trackCPDModalVisible} callbackDelay={1000}>
      <>
        <div className={styles['img']} style={{ backgroundImage: `url(${mainImgUrl})` }} />
        <div className={styles['title']}>
          <UIHeading2>{title}</UIHeading2>
        </div>
        <div className={styles['list']}>
          {points.map((point, i) => {
            return (
              <div key={i} className={styles['row']}>
                <div className={styles['icon']}>
                  <img src={point.iconUrl} />
                </div>
                <UIText2>{point.text}</UIText2>
              </div>
            );
          })}
        </div>
        <div className={styles['controls']}>
          <Button loading={cpdDraftStatus === ECpdDraftStatus.loading} onClick={onCreateDraftCpd} theme="fill_primary">
            {primaryBtnText}
          </Button>
          {secondaryBtn && (
            <LinkButton onClick={trackCPDDetailClick} href={cpdLandingLink} target="_blank" theme="fill_secondary">
              {secondaryBtn.text}
            </LinkButton>
          )}
        </div>
        <div className={styles['secury']}>
          <UIText3 color="gray60_100">
            Нажимая «Позвоните мне», я даю 
            <a href={securyPersonalUrl} target="_blank" className={styles['link']} rel="noreferrer">
              Согласие на обработку персональных данных
            </a>{' '}
            в соответствии с 
            <a href={securyСonfidentialityUrl} target="_blank" className={styles['link']} rel="noreferrer">
              Политикой конфиденциальности
            </a>
          </UIText3>
        </div>
      </>
    </ActionAfterViewObserver>
  );
};
